﻿export class RioAutoCompleteResult {
    label: string;
    value: string;
    data?: any;
}